<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-snackbar v-model="snackbar" :color="snackColor" right bottom :timeout="4000">
        {{ snackText }}
        <template #action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
        </template>
      </v-snackbar>

      <!-- LIGHTBOX -->
      <v-dialog v-model="lightbox.show" max-width="900px" @click:outside="lightbox.show = false">
        <v-card style="background:#000; position:relative;">
          <v-btn
            fab small dark absolute top right
            style="top:8px; right:8px; z-index:1;"
            color="grey darken-3"
            @click="lightbox.show = false"
          >
            <v-icon>fas fa-times</v-icon>
          </v-btn>
          <div class="text-center pa-2" style="font-size:13px; color:#aaa; padding-top:14px;">
            {{ lightbox.titulo }}
          </div>
          <img
            :src="normalizarRuta(lightbox.url)"
            style="max-width:100%; max-height:80vh; display:block; margin:0 auto; object-fit:contain;"
            alt="vista foto"
          />
        </v-card>
      </v-dialog>

      <!-- DIALOG ELIMINAR -->
      <v-dialog v-model="dialogEliminar" persistent max-width="420px">
        <v-card>
          <v-card-text class="pt-6 pb-2 text--primary">
            <div class="text-h6 font-weight-medium mb-3">Remover foto</div>
            <div class="font-weight-regular" style="font-size:16px">
              ¿Está seguro que desea eliminar la foto de
              <strong>{{ etiqueta(tipoEliminar) }}</strong>?
            </div>
            <div class="text-center mt-4">
              <v-icon color="error" size="60">fa-trash-alt</v-icon>
            </div>
          </v-card-text>
          <v-card-actions class="pb-4 px-4">
            <v-spacer />
            <v-btn color="primary" outlined min-width="120" @click="confirmarEliminar">Sí, eliminar</v-btn>
            <v-btn color="primary" dark min-width="120" @click="dialogEliminar = false">Cancelar</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ENCABEZADO -->
      <v-card elevation="0">
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="font-weight:500">Fotos de la vivienda</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <p class="body-2 grey--text text--darken-1 mb-4">
            Suba una foto del <strong>frente de la vivienda</strong> , sala
            <strong>cocina y patio</strong>. Formatos permitidos: JPG o PNG (máx. 15 MB).
          </p>

          <!-- GRID DE SLOTS -->
          <v-row>
            <v-col
              v-for="slot in slots"
              :key="slot.tipoFoto"
              cols="12" sm="6" md="3"
            >
              <v-card
                outlined
                class="foto-slot d-flex flex-column align-center justify-center pa-3"
                :class="{ 'foto-slot--cargada': slot.fotoPath }"
                style="min-height:220px; border-radius:12px; position:relative;"
              >
                <!-- Etiqueta del slot -->
                <div class="slot-label text-center font-weight-medium mb-2" style="font-size:13px;">
                  <v-icon left small :color="slot.fotoPath ? 'success' : 'grey'">
                    {{ slot.fotoPath ? 'fas fa-check-circle' : 'fas fa-camera' }}
                  </v-icon>
                  {{ etiqueta(slot.tipoFoto) }}
                </div>

                <!-- Preview / Placeholder -->
                <div
                  class="foto-preview"
                  :class="{ 'foto-preview--clickable': slot.fotoPath && !slot.cargando }"
                  @click="slot.fotoPath && !slot.cargando ? verFoto(slot) : null"
                >
                  <!-- Imagen cargada -->
                  <template v-if="slot.fotoPath && !slot.cargando">
                    <img
                      :src="normalizarRuta(slot.fotoPath)"
                      class="foto-img"
                      alt="foto vivienda"
                    />
                  </template>

                  <!-- Spinner mientras se sube -->
                  <template v-else-if="slot.cargando">
                    <v-progress-circular indeterminate color="primary" size="40" />
                    <div style="font-size:11px; color:#999; margin-top:6px;">Subiendo...</div>
                  </template>

                  <!-- Sin foto -->
                  <template v-else>
                    <v-icon size="48" color="grey lighten-1">fas fa-image</v-icon>
                    <div style="font-size:11px; color:#aaa; margin-top:4px;">Sin foto</div>
                  </template>
                </div>

                <!-- Acciones -->
                <div class="mt-3 d-flex" style="gap:8px;">
                  <!-- Botón subir / reemplazar -->
                  <v-tooltip bottom color="primary" max-width="200">
                    <template #activator="{ on }">
                      <v-btn
                        small
                        :color="slot.fotoPath ? 'amber darken-2' : 'primary'"
                        dark
                        :disabled="completada || slot.cargando"
                        v-on="on"
                        @click="abrirSelector(slot)"
                      >
                        <v-icon small left>{{ slot.fotoPath ? 'fas fa-sync-alt' : 'fas fa-upload' }}</v-icon>
                        {{ slot.fotoPath ? 'Cambiar' : 'Subir' }}
                      </v-btn>
                    </template>
                    <span>{{ slot.fotoPath ? 'Reemplazar foto' : 'Subir foto' }}</span>
                  </v-tooltip>

                  <!-- Botón ver -->
                  <v-tooltip v-if="slot.fotoPath" bottom color="primary">
                    <template #activator="{ on }">
                      <v-btn small text icon color="primary" v-on="on" @click="verFoto(slot)">
                        <v-icon small>fas fa-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver foto</span>
                  </v-tooltip>

                  <!-- Botón eliminar -->
                  <v-tooltip v-if="slot.fotoPath" bottom color="error">
                    <template #activator="{ on }">
                      <v-btn
                        small text icon color="error"
                        :disabled="completada || slot.cargando"
                        v-on="on"
                        @click="pedirEliminar(slot)"
                      >
                        <v-icon small>fas fa-trash-alt</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar foto</span>
                  </v-tooltip>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Input de archivo oculto -->
      <input
        ref="fileInput"
        type="file"
        accept="image/png,image/jpeg,image/bmp"
        style="display:none"
        @change="onFileSelected"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

const TIPOS = ['FRENTE', 'INTERIOR_1', 'INTERIOR_2', 'INTERIOR_3']
const ETIQUETAS = {
  FRENTE: 'Frente de la vivienda',
  INTERIOR_1: 'Sala',
  INTERIOR_2: 'Cocina',
  INTERIOR_3: 'Patio'
}

export default {
  name: 'FormBecaFotoVivienda',
  props: {
    solicitudBecaId: { type: Number, default: null },
    completada: { type: Boolean, default: false }
  },
  data: () => ({
    slots: TIPOS.map((t) => ({ tipoFoto: t, fotoPath: null, fotoViviendaId: 0, cargando: false })),
    slotActivo: null,

    // Lightbox
    lightbox: { show: false, url: '', titulo: '' },

    // Eliminar
    dialogEliminar: false,
    tipoEliminar: '',

    // Snackbar
    snackbar: false,
    snackText: '',
    snackColor: 'primary'
  }),
  watch: {
    solicitudBecaId(val) {
      if (val != null) this.listarFotos()
    }
  },
  created() {
    if (this.solicitudBecaId != null) this.listarFotos()
  },
  methods: {
    etiqueta(tipo) {
      return ETIQUETAS[tipo] || tipo
    },

    listarFotos() {
      axios
        .get(`api/solicitudesdebecas/${this.solicitudBecaId}/FotoVivienda`)
        .then(({ data }) => {
          data.forEach((f) => {
            const slot = this.slots.find((s) => s.tipoFoto === f.tipoFoto)
            if (slot) {
              slot.fotoPath = f.fotoPath || null
              slot.fotoViviendaId = f.fotoViviendaId
            }
          })
        })
        .catch((err) => console.error(err))
    },

    abrirSelector(slot) {
      this.slotActivo = slot
      this.$refs.fileInput.value = ''
      this.$refs.fileInput.click()
    },

    onFileSelected(event) {
      const file = event.target.files[0]
      if (!file || !this.slotActivo) return

      if (!['image/png', 'image/jpeg', 'image/bmp'].includes(file.type)) {
        this.mostrarSnack('Solo se permiten imágenes PNG o JPG.', 'snackError')
        return
      }
      if (file.size > 15 * 1024 * 1024) {
        this.mostrarSnack('El archivo no puede pesar más de 15 MB.', 'snackError')
        return
      }

      this.subirFoto(this.slotActivo, file)
    },

    subirFoto(slot, file) {
      // Previsualización local inmediata mientras se sube
      const previewUrl = URL.createObjectURL(file)
      slot.fotoPath = previewUrl
      slot.cargando = true

      const formData = new FormData()
      formData.append('file', file, file.name)

      axios
        .post(
          `api/solicitudesdebecas/${this.solicitudBecaId}/FotoVivienda/${slot.tipoFoto}`,
          formData
        )
        .then(({ data }) => {
          URL.revokeObjectURL(previewUrl)
          slot.fotoPath = data.fotoPath
          slot.fotoViviendaId = data.fotoViviendaId
          this.mostrarSnack('Foto guardada exitosamente.', 'snackSuccess')
          this.$emit('updated')
        })
        .catch(() => {
          URL.revokeObjectURL(previewUrl)
          slot.fotoPath = null
          this.mostrarSnack('No se pudo subir la foto.', 'snackError')
        })
        .finally(() => {
          slot.cargando = false
        })
    },

    verFoto(slot) {
      this.lightbox.url = slot.fotoPath
      this.lightbox.titulo = this.etiqueta(slot.tipoFoto)
      this.lightbox.show = true
    },

    pedirEliminar(slot) {
      this.tipoEliminar = slot.tipoFoto
      this.dialogEliminar = true
    },

    confirmarEliminar() {
      const slot = this.slots.find((s) => s.tipoFoto === this.tipoEliminar)
      if (!slot) return
      this.dialogEliminar = false
      slot.cargando = true

      axios
        .delete(
          `api/solicitudesdebecas/${this.solicitudBecaId}/FotoVivienda/${slot.tipoFoto}`
        )
        .then(() => {
          slot.fotoPath = null
          slot.fotoViviendaId = 0
          this.mostrarSnack('Foto eliminada.', 'snackSuccess')
          this.$emit('updated')
        })
        .catch(() => {
          this.mostrarSnack('No se pudo eliminar la foto.', 'snackError')
        })
        .finally(() => {
          slot.cargando = false
        })
    },

    normalizarRuta(path) {
      if (!path) return ''
      // Blob URL local (createObjectURL) — usar tal cual
      if (path.startsWith('blob:')) return path
      // URL ya absoluta — usar tal cual
      if (path.startsWith('http')) return path
      // Ruta relativa del servidor: agregar la base de la API
      const limpia = path.replace(/\\/g, '/')
      const base = (process.env.VUE_APP_API || '').replace(/\/$/, '')
      const ruta = limpia.startsWith('/') ? limpia.slice(1) : limpia
      return `${base}/${ruta}`
    },

    mostrarSnack(text, color) {
      this.snackText = text
      this.snackColor = color
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
.foto-slot {
  border: 2px dashed #bdbdbd;
  transition: border-color 0.2s;
}
.foto-slot--cargada {
  border-color: #4caf50;
  border-style: solid;
}

/* Contenedor de previsualización */
.foto-preview {
  width: 100%;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}
.foto-preview--clickable {
  cursor: pointer;
}

/* Imagen */
.foto-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

</style>
